import { render, staticRenderFns } from "./AddPopup.vue?vue&type=template&id=6abca021&scoped=true"
import script from "./AddPopup.vue?vue&type=script&lang=js"
export * from "./AddPopup.vue?vue&type=script&lang=js"
import style0 from "./AddPopup.vue?vue&type=style&index=0&id=6abca021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abca021",
  null
  
)

export default component.exports